const PricesCell = ({ currency, prices }) => {
  if (!prices) return "No price data";

  return (
    <div className="whitespace-nowrap">
      {prices.map((p, index) => (
        <div key={index}>
          {prices.length > 1 && `For quantity ${p.qty}:`} {currency} {p.price}
        </div>
      ))}
    </div>
  );
};

export default PricesCell;
